import React from 'react';
import customAxios from '../../API/customAxios';

export async function submitRequest(data, totalHours, action, description, items) {
    return await customAxios.post(`/submit_comp_leave_req`, {
        data: data,
        totalHours: totalHours,
        action: action,
        description: description,
        items: items
    });
}
